import { render, staticRenderFns } from "./chose_specs.vue?vue&type=template&id=5b39c4a4&scoped=true&"
import script from "./chose_specs.vue?vue&type=script&lang=js&"
export * from "./chose_specs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39c4a4",
  null
  
)

export default component.exports